__webpack_require__.p = "https://assets.worldcubeassociation.org/nextjs/653ca18be108b58a8d014f14e17d17db72c8d402/_next/";